module.exports = __webpack_public_path__ + "img/4.118cde38.svg";